import { IGuest } from "../../models/base/Guest";
import { Plugin, PluginContext } from "../plugin";
import { config } from "@fidget/common/config/config";

export class OrangeCrmPlugin implements Plugin {
  public readonly id: string = "orange_crm";

  private context?: PluginContext;

  configure = (context: PluginContext, pluginConfig: any) => {
    this.context = context;
  };

  omniButtonClick = (guest: IGuest) => {
    const apiUrl = `${config.services.tangerine.baseUrl}/${this.context?.orgId}/${this.id}/${guest.roomId}`;
    fetch(apiUrl, {
      headers: {
        "X-Api-Key": this.context?.currentAgentApiKey || "",
      }
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.uri) {
          window.open(r.uri);
        }
      });
  };
}
